<template>
  <b-modal id="modal-proposta-renegociacao" size="xl" ref="modalPropostaRenegociacao" :hide-header-close="false"   :no-close-on-esc="false"   :no-close-on-backdrop="false">
      <template v-slot:modal-header>
          <h5 v-if="!loading">Propostas de Renegociação</h5>
          <b-button size="sm" variant="outline-secondary" @click="fechar">
            &times;
          </b-button>
      </template>

      <template v-slot:default>
          <div v-if="loading" class="text-center p-4">
              <b-spinner variant="primary" style="width: 3rem; height: 3rem" label="Carregando..."></b-spinner>
              <p>Carregando dados das propostas...</p>
          </div>

          <div v-else>
            <div v-if="propostas.length === 0" class="text-center p-4 text-muted">
              <b-icon icon="inbox" font-scale="2"></b-icon>
              <p class="mt-2">Nenhuma proposta aqui por enquanto...</p>
            </div>

              <b-table v-else :items="propostas" :fields="fields" bordered responsive thead-class="center-th">
                  <template #cell(vl_proposta)="data">
                      {{ formatCurrency(data.item.vl_proposta) }}
                  </template>
                  <template #cell(vl_custa_cancelamento)="data">
                      {{ formatCurrency(data.item.vl_custa_cancelamento) }}
                  </template>
                  <template #cell(vl_taxa_servico)="data">
                      {{ formatCurrency(data.item.vl_taxa_servico) }}
                  </template>
                  <template #head(vl_taxa_servico)="{ label }">
                    <span>
                      Custo Plataforma
                      <b-icon
                        icon="info-circle"
                        class="ml-1 info-icone"
                        v-b-popover.hover.focus="'Preço de utilização da plataforma'"
                        title=""
                      ></b-icon>
                    </span>
                  </template>
                  <template #cell(dt_vencimento_proposta)="data">
                      {{ data.item.dt_vencimento_proposta_fmt || formatDate(data.item.dt_vencimento_proposta) }}
                  </template>
                  <template #cell(vl_total_pagar)="data">
                      {{ formatCurrency(totalPagar(data.item)) }}
                  </template>
                  <template #cell(actions)="data">
                    <div class="d-flex justify-content-between align-items-center">
                      <b-button size="sm" variant="info" @click="abrirDetalhes(data.item)">
                        Detalhes
                      </b-button>
                      <b-button v-if="data.item.cd_renegociacao_divida_status != 3 && data.item.cd_renegociacao_divida_status != 4" size="sm" variant="success" @click="aceitarProposta(data.item)">
                        Aceitar
                      </b-button>
                      <b-button v-if="data.item.cd_renegociacao_divida_status != 3 && data.item.cd_renegociacao_divida_status != 4" size="sm" variant="danger" @click="recusarProposta(data.item)">
                        Recusar
                      </b-button>
                      <div v-if="data.item.cd_renegociacao_divida_status == 3" class="w-100 d-flex justify-content-center align-items-center">
                        <font-awesome-icon icon="dollar-sign" class="text-primary" style="font-size:2.2em;" title="Gerar Pagamento" @click="gerarPagamento(data.item)"/>
                      </div>
                      <div v-else-if="data.item.cd_renegociacao_divida_status == 4" class="w-100 d-flex justify-content-center align-items-center">
                        <font-awesome-icon icon="dollar-sign" class="text-success" style="font-size:2.2em;" title="Exibir Pagamento" @click="exibirPagamento(data.item)" />
                      </div>
                    </div>
                  </template>
              </b-table>
          </div>
      </template>

      <template v-slot:modal-footer>
          <b-button variant="secondary" @click="fechar">Fechar</b-button>
      </template>
  </b-modal>
</template>

<script>
import API from '@/services/api';

export default {
  name: 'ModalPropostaRenegociacao',
  data() {
      return {
          loading: false,
          propostas: [],
          fields: [
              { key: 'cd_renegociacao_divida', label: 'Nº Pedido', class: 'text-center'},
              { key: 'vl_proposta', label: 'ValorProposta', class: 'text-center' },
              { key: 'vl_custa_cancelamento', label: 'Custas Cancelamento', class: 'text-center' },
              { key: 'vl_taxa_servico', label: 'Custo Plataforma', class: 'text-center' },
              { key: 'dt_vencimento_proposta', label: 'Vencimento', class: 'text-center' },
              { key: 'vl_total_pagar', label: 'Total a Pagar', class: 'text-center' },
              { key: 'actions', label: 'Ações', class: 'text-center' }
          ],
      }
  },
  methods: {
    async abrir(documento) {
        this.loading = true;
        this.propostas = [];
        this.$refs.modalPropostaRenegociacao.show();

        try {
          const token = localStorage.getItem('jwtToken');
          const res = await API.post('renegociacao_divida_protestada/detalhes-proposta', {
            token,
            nm_nr_documento_devedor: documento
          });
          if (res.data.success) {
            this.propostas = res.data.data;
          }
        } catch (err) {
          console.error('Erro ao buscar propostas:', err);
        } finally {
          this.loading = false;
        }
      },

      async abrirPorChaveUnica(chaveUnica) {
        this.loading = true;
        this.propostas = [];
        this.$refs.modalPropostaRenegociacao.show();
        try {
          const token = localStorage.getItem('jwtToken');
          const res = await API.post('renegociacao_divida_protestada/detalhes-proposta', {
            token,
            nm_chave: chaveUnica
          });
          if (res.data.success && res.data.data && res.data.data.length > 0) {
            // Filtra apenas a proposta da chave única
            this.propostas = res.data.data.filter(p => p.nm_chave === chaveUnica);
          }
        } catch (err) {
          console.error('Erro ao buscar proposta por chave única:', err);
        } finally {
          this.loading = false;
        }
      },

      aceitarProposta(proposta) {
          this.$emit('acao', { acao: 'aceita', proposta });
      },
      recusarProposta(proposta) {
        this.$emit('acao', { acao: 'recusa', proposta });
      },
      gerarPagamento(proposta) {
          this.$emit('acao', { acao: 'gerarPagamento', proposta });
      },
      exibirPagamento(proposta) {
          this.$emit('acao', { acao: 'exibirPagamento', proposta });
      },
      fechar() {
          this.$refs.modalPropostaRenegociacao.hide();
      },
      formatCurrency(valor) {
          return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor);
      },
      formatDate(data) {
          if (!data) return '';
          // Se vier como dd/mm/yyyy, retorna direto
          if (/^\d{2}\/\d{2}\/\d{4}$/.test(data)) return data;
          // Se vier como yyyy-mm-dd, converte para dd/mm/yyyy
          if (/^\d{4}-\d{2}-\d{2}$/.test(data)) {
            const parts = data.split('-');
            return `${parts[2]}/${parts[1]}/${parts[0]}`;
          }
          return data;
      },
      abrirDetalhes(proposta) {
        this.$emit('acao', { acao: 'detalhes', proposta });
      },
      removerProposta(cd) {
        this.propostas = this.propostas.filter(p => p.cd_renegociacao_divida !== cd);
      },
      abrirModalPagamento(proposta) {
        // Lógica para abrir o modal de pagamento
        this.$emit('acao', { acao: 'pagamento', proposta });
      },
      gerarBoleto(proposta) {
        // Lógica para gerar boleto
        this.$emit('acao', { acao: 'gerarBoleto', proposta });
      },
      selecionarBoleto(proposta) {
        // Lógica para selecionar e exibir boleto
        this.$emit('acao', { acao: 'selecionarBoleto', proposta });
      },
      totalPagar(item) {
        const v1 = parseFloat(item.vl_proposta) || 0;
        const v2 = parseFloat(item.vl_custa_cancelamento) || 0;
        const v3 = parseFloat(item.vl_taxa_servico) || 0;
        return v1 + v2 + v3;
      },
  }
}
</script>

<style>
.text-right {
  text-align: right;
}

/* Melhora visual da tabela de propostas de renegociação */
.center-th th {
  background: #4576a8 !important;
  color: #fff !important;
  white-space: normal !important;
  vertical-align: middle !important;
  font-size: 1rem;
  font-weight: 600;
  /* border-top-left-radius: 8px; */
  /* border-top-right-radius: 8px; */
  padding: 10px 8px !important;
}

.b-table tbody tr:nth-child(even) {
  background: #f6f8fa;
}

.b-table {
  /* Removido border-radius e overflow para evitar bordas arredondadas e scroll */
  width: 100%;
}

.b-table td, .b-table th {
  padding: 7px 6px !important;
  vertical-align: middle !important;
}

.b-table .btn {
  margin: 0 2px;
  padding: 0.3rem 0.7rem;
  font-size: 0.95rem;
}

.b-table .d-flex {
  gap: 0.3rem;
}

.b-table th, .b-table td {
  border-color: #d1dbe6 !important;
}

/* Estilo opcional para alinhar o ícone */
.info-icone {
  cursor: pointer;
  color: #4576a8;
  font-size: 1.1em;
  vertical-align: middle;
}
</style>
